import React, {useRef} from 'react'
import "./home.css"
import Video from '../video/video';
import Audio from '../audio/audio';


const Home = (props) => {
    const actorName="JOE";
    const actorTitle="Security Guard";
    const playVideo = useRef(null);
    const posterURL = './actors/JOE.png';

    const updateVideoStatue =(value)=>{
       
        if(value ==="ended"){
            props.goToStep(null,"SecurityRoomConfirmation");
        }

    }

    return (<>
        <div className="Home fullscreen">
            <Video VideoURL="./videos/2_1_General_Intro.mp4" poster={posterURL} actorName={actorName} actorTitle={actorTitle} updateVideoStatue={updateVideoStatue} playVideo={playVideo} />
            {/* <button onClick={eventHandler} id="StartGame">Start Game</button> */}
        </div>
        <Audio AudioURL="./musics/the-crackdown.mp3" />
        </>
    );
}

export default Home;